enum DiagramType {
	mermaid = "Mermaid",
	"plant-uml" = "Plant-uml",
}

export default DiagramType;
